import { useEffect } from "react";
import styled from "styled-components";
import { AiFillSetting } from "react-icons/ai";
import { IoEyeSharp } from "react-icons/io5";
import TableControl from "../../component/table/TableControl";
import { Button } from "antd";
import { Link } from 'react-router-dom';
import Switch from "../../component/switch/Index";

const ButtonToListAll = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
  border: 0.75px solid #E6E6E6;
  box-sizing: border-box;
  box-shadow: 1px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;

  @media only screen and (max-width: 1024px){
    font-size: 18px;
    height: 40px;
    img{ width: 24px; margin-right: 10px;}
  }

  @media only screen and (max-width: 768px){
    font-size: 16px;
    height: 40px;
    img{ width: 24px; margin-right: 10px;}
  }
  
  @media only screen and (max-width: 450px){
    font-size: 16px;
    height: 40px;
    img{ width: 24px; margin-right: 10px;}
  }

  @media only screen and (max-width: 376px){
    font-size: 14px;
    height: 40px;
    img{ width: 24px; margin-right: 10px;}
  }

  @media only screen and (min-width: 1200px){
    font-size: 14px;
    height: 40px;
    img{ width: 24px; margin-right: 10px;}
  }
`

export default function TableListAllStation(props) {
    useEffect(() => {

    }, []);


    const ButtonToListAllStation = (
        <Link to={'/mgt-station'}>
            <ButtonToListAll className='button-to__list-all-station' icon={<img src='/image/railway-station.png' alt="icon-railway-station"/>}>
                จัดการสถานี
            </ButtonToListAll>
        </Link>
    )
    const column = [
      { title: "จังหวัด", dataIndex: "province", align: "center", className: "cn allow-search", sorter: (a, b) => a.province.localeCompare(b.province)},
      { title: "สถานี", dataIndex: "name_th", align: "center", className: "cn allow-search", sorter: (a, b) => a.name_th.localeCompare(b.name_th)},
      { title: "สถานะ", dataIndex: "status", align: "center", className: "cn", sorter: (a, b) => a.status - b.status,
      render: (_, record) => (
        <Switch checkedChildren="เปิดใช้งาน" unCheckedChildren="ปิดใช้งาน" checked={record.status == 1 ? true : false} />
      )},
      { title: <AiFillSetting/>, dataIndex: "graph", align: "center", width: 40, className:"cell-graph", 
      render: (_, record) => (
        <>
           <Link to={'/stations/'+record.id}><Button><IoEyeSharp style={{color: "#006994"}}/></Button></Link>
        </>
      ),
      },
    ]

    return (
        <TableControl
          className={
            "table-dashboard__stations" +
            (props.className ? props.className : "")
          }
          topRightButton = {props.per != '["view"]' && props.per != '[]' ? ButtonToListAllStation : ''}
          rowKey={'id'}
          data={props.data}
          filterData={props.filterData} 
          fncSetFilterData={props.fncSetFilterData}
          columns={column}
          dataSet={1}
        />
      );
}